import { useSelector } from "react-redux";
import InfoBar from "../../../../../../shared/components/ui/infoBar/InfoBar";
import classes from "./SetNewCourseName.module.css"

const SetNewCourseName = ({ courseData, setCourseData }) => {

    const { texts } = useSelector(state => state.translate);

    const handleChange = (e) => {
        setCourseData(pre => ({ ...pre, newName: e.target.value }))
    }

    return (
        <>
            {courseData &&
                <div className={classes.SetNewCourseName}>
                    <div className={classes.MobileHeadings}>
                        <p className={classes.SectionTitle}>{texts.createStudySpaceName}</p>
                        <p className={classes.Instruction}>{texts.enterStudySpaceName}</p>
                    </div>
                    <p className={classes.Name}>{texts.setCourseName}</p>
                    <label className={classes.InputLabel}>{texts.studySpaceNameLabel}</label>
                    <input
                        className={classes.InputName}
                        value={courseData.newName || ""}
                        onChange={handleChange}
                        placeholder={texts.studySpaceNamePlaceholder}
                    />
                    <div className={classes.TipWrapper}>
                        <InfoBar text={texts.studySpaceNameTip} />
                    </div>
                </div>
            }
        </>
    )
}

export default SetNewCourseName;
